import { IForm } from "../../Interface/IForm";

import {
	ProfileGroup,
} from "./FormGroup";


export const ProfileForm: IForm = {
	id: "profileform",
	groups: [ProfileGroup],
	isValid: false,
	isVisible: true,
	title:""
};

export const ProfileForms : IForm[] = [ProfileForm];
